/* Packages */
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from "conversie-flow-bundle/assets/js/components/flow/hooks/useValidation";

/* Symbols */
import toolTip from 'symbols/tooltip.svg';
import arrowIcon from 'symbols/arrow.svg';
import iconClose from 'symbols/close.svg'

/* Atoms */
import { Icon } from "js/components/atoms";

/* Organisms */
import { Modal } from 'js/components/organisms';

/* Swiper */
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

/* Config */
import { SWIPER_CONFIG } from 'js/config/swiper';

/* Utilities */
import { getImageFraction } from 'js/utilities';

export default function FlowFieldChoice(props) {
    const { colClassName, field, inputType, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, placeholder = null, value, name } = field;

    const [modalOpen, setModalOpen] = useState(false);

    const [modalData, setModalData] = useState({
        title: '',
        content: '',
        images: [],
    });

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const handleTooltipClick = (choice) => {
        const currentSliderId = `${Math.floor(Math.random() * 1000000)}`;
        let modifiedImages = [];

        if (choice.tooltipImages && choice.tooltipImages.length > 0) {
            modifiedImages = choice.tooltipImages.map((image, imageIndex) => ({
                alt: '',
                width: 590,
                height: 393,
                ...getImageFraction({
                    path: image,
                    ratio: 3 / 2,
                    fraction: 1,
                }),
            }));
        }

        setModalData({
            title: choice.label,
            content: choice.tooltip,
            images: modifiedImages,
            sliderId: currentSliderId,
        });
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalData({
            title: '',
            content: '',
            images: [],
        });
        setModalOpen(false);
    };

    return (
        <div className={`${colClassName}`}>
            <Form.Group className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {choices?.map((choice, choiceIndex) => {
                    return (
                        <Form.Check
                            key={choice.key}
                            className={`custom-control custom-${inputType} ${error ? 'is-error' : ''} ${choice.tooltip || (choice.tooltipImages && choice.tooltipImages.length > 0) ? 'd-flex gap-1 align-items-center' : ''}`}
                            type={inputType}
                            id={`${id}.choices.${choiceIndex}-${choice.key}`}
                        >
                            <Form.Check.Input
                                type={inputType}
                                className="custom-control-input"
                                name={id}
                                value={choice.key}
                                {...{
                                    required,
                                    disabled,
                                    placeholder,
                                }}
                                checked={value?.includes(choice.key)}
                                onChange={(e) => {
                                    updateChoice(choice, e.target.checked, () => {
                                        trigger(path);
                                    });
                                }}
                            />
                            {choice.tooltip || (choice.tooltipImages && choice.tooltipImages.length > 0) ? (
                                <>
                                    <Form.Check.Label
                                        className="custom-control-label"
                                        dangerouslySetInnerHTML={{ __html: choice.label }}
                                    />
                                    <div className="d-flex btn--tooltip" onClick={() => handleTooltipClick(choice)}>
                                        <Icon theme="" size={20} url={toolTip} />
                                    </div>
                                </>
                            ) : (
                                <Form.Check.Label className="custom-control-label" dangerouslySetInnerHTML={{ __html: choice.label }} />
                            )}
                        </Form.Check>
                    );
                })}
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Modal
                open={modalOpen}
                handleClose={handleCloseModal}
                title='Derks Bedrijfswagens'
                images={modalData.images}
                bodyTitle={modalData.title}
                footer={
                    <div className="d-flex align-content-center pt-6">
                        <button className='btn btn-base' onClick={handleCloseModal}>
                            <span className='btn__text'>Sluiten</span>
                            <div className="btn__icon"><Icon theme="" size={24} url={iconClose} /></div>
                        </button>
                    </div>
                }
            >
                {modalData.images && modalData.images.length > 0 && (
                    <div className="position-relative pb-6">
                        <Swiper
                            id={modalData.sliderId}
                            {...SWIPER_CONFIG}
                            modules={[Navigation, Pagination]}
                            navigation={{
                                prevEl: '.swiper-button-prev',
                                nextEl: '.swiper-button-next',
                            }}
                            pagination={{ clickable: true, }}
                            spaceBetween={0}
                            slidesPerView={1}
                            loop
                        >
                            {modalData.images?.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <img
                                        {...{
                                            src: 'placeholder',
                                            alt: 'Tooltip image',
                                        }}
                                        {...image}
                                        className="img-fluid rounded"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div id={`${modalData.sliderId}-prev`} className="swiper-button-prev">
                            <Icon url={arrowIcon} size={24} />
                        </div>
                        <div id={`${modalData.sliderId}-prev`} className="swiper-button-next">
                            <Icon url={arrowIcon} size={24} />
                        </div>
                    </div>
                )}

                <div dangerouslySetInnerHTML={{ __html: modalData.content }} />
            </Modal>
        </div>
    );
}
